import { PreApprovalBorrower, LoanApplicationBorrower } from "../types/api";

/** Given substrings for first name, last name, etc, returns a properly-formatted (human) name
 * @param  {string=""} firstName
 * @param  {string=""} middleName
 * @param  {string=""} lastName
 * @param  {string=""} suffix
 * @returns string
 */
export const formatName = (
  firstName: string = "",
  middleName: string = "",
  lastName: string = "",
  suffix: string = "",
): string => {
  let name: string;
  if (middleName) {
    name = `${firstName} ${middleName} ${lastName}`;
  } else {
    name = `${firstName} ${lastName}`;
  }
  return suffix ? `${name}, ${suffix}` : name;
};

export const borrowerToName = (borrower: PreApprovalBorrower | LoanApplicationBorrower): string => {
  const { first_name: firstName, middle_name: middleName, last_name: lastName, suffix } = borrower;

  let name: string;
  if (middleName) {
    name = `${firstName} ${middleName} ${lastName}`;
  } else {
    name = `${firstName} ${lastName}`;
  }
  return suffix ? `${name}, ${suffix}` : name;
};
